import { useEffect, useState } from "react";

import FormModal from "../../widgets/FormModal";

function About() {

    const [show, setShow] = useState(false);
    const openIframeWindow = () => {
      setShow(!show);
    }

  return (
    <>
 <section className="about">
  <div className="container">
    <div className="row     align-items-center">
      <div className="col-md-6 mb-md-0 mb-4">
         <img src="/assets/img/about-logo.svg" alt="about-logo" className='mb-3 h70 ' /> 
        <h2 className="hadding   mb-4  ">India’s most successful genetic-based lifestyle modification program</h2>
        <p>EPLIMO combines your DNA, metabolism, and lifestyle data to create a personalized plan that prevents risks and unlocks peak performance.</p>
        <a className="btn mt-3" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
      </div> 
      <div className="col-md-6"> 
        <img src="/assets/img/logobg.png" alt="logobg" className="img-fluid" /> 
      </div>
    </div>
  </div>
   <FormModal show={show} setShow={setShow} />
</section>

    </>
  )
}

export default About